import React, { useState } from "react";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import axios from "axios";
import Visibility from "@mui/icons-material/Visibility";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {} from "../../Redux/Actions/actions";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";

const mapStateToProps = (state) => {
  const { data } = state;
  return {
    selectedusername: data.selectedusername,
  };
};

const ChangesPasswordModel = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const { OpenDialog, handleClose } = props;
  const [oldpassword, setoldpassword] = useState("");
  const [newpassword, setnewpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [newpasswordValidation, setnewpasswordValidation] = useState(false);
  const [passwordValidation, setpasswordValidation] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const submitNewPassword = () => {
    if (
      newpassword !== confirmpassword ||
      !oldpassword ||
      !newpassword ||
      !confirmpassword
    ) {
      setpasswordValidation(true);
      return;
    }

    const data = {
      emailId: JSON.parse(localStorage.getItem("tokenAgent")).email,
      oldPassword: oldpassword,
      password: newpassword,
      confirmPassword: confirmpassword,
    };
    axios
      .post(BaseUrl + "/userstatus/updatePassword", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          handleClose();
          toast.success(res.data.message, toaststyle);
        } else {
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {});
  };

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      sx={{
        "& .MuiPaper-root": {
          padding: 1,
          width: 600,
          maxWidth: 600,
        },
        backgroundColor: "rgb(0 0 0 / 15%)",
      }}
    >
      <DialogTitle
        variant="subtitle2"
        sx={{ fontSize: "16px", fontWeight: 600 }}
      >
        Change Password
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack spacing={3} sx={{ marginTop: "10px" }}>
            <TextField
              id="old-password-input"
              label="Old Password"
              type={showPassword ? "text" : "password"}
              value={oldpassword}
              error={passwordValidation}
              helperText={passwordValidation ? "Passwords required" : ""}
              onChange={(e) => setoldpassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="new-password-input"
              label="New Password"
              type="password"
              value={newpassword}
              error={passwordValidation}
              helperText={passwordValidation ? "Passwords required" : ""}
              onChange={(e) => setnewpassword(e.target.value)}
            />
            <TextField
              id="confirm-password-input"
              label="Confirm Password"
              type="text"
              value={confirmpassword}
              error={newpasswordValidation || passwordValidation}
              helperText={
                newpasswordValidation
                  ? "Passwords do not match"
                  : passwordValidation
                    ? "Passwords required"
                    : ""
              }
              onChange={(e) => {
                setconfirmpassword(e.target.value);
                setnewpasswordValidation(e.target.value !== newpassword);
              }}
            />
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" size="small" onClick={submitNewPassword}>
          SUBMIT
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {})(ChangesPasswordModel);
